'use strict';

module.exports = require('./is-implemented')()
	? String.prototype.contains
	: require('./shim');



/*****************
 ** WEBPACK FOOTER
 ** /Users/bvaughn/Documents/git/react-devtools/~/es5-ext/string/#/contains/index.js
 ** module id = 22
 ** module chunks = 0
 **/